import React from 'react';
import { GET_INVITES_ENDPOINT, InviteType } from '../../types/AnalyticsApi';
import { DataPoint, HandledData, TimeSeriesDataPoint } from '../../types/CompositeDataProvider';
import CompositeDataProvider from '../DataProviders/CompositeDataProvider';
import Legend from '../Legends/Legend';
import LineChartContainer from '../LineChart/LineChartContainer';
import ChartSectionContainer from '../Section/ChartSectionContainer';
import SectionChart from '../Section/SectionChart';
import SectionHeader from '../Section/SectionHeader';

interface DashboardInvitesStatsChartProps {
    countryCode?: string[] | null;
    from?: string | null;
    to?: string | null;
    companyId?: string[] | null;
    departmentId?: string[] | null;
}

const addToInterval = (intervals: Map<number, DataPoint[]>, date: number, key: string, value: number) => {
    if (!intervals.has(date)) {
        intervals.set(date, []);
    }

    intervals.get(date)?.push({
        key,
        value
    });
};

const dataMerger = (dataSets: HandledData[]) => {
    let mergedData: TimeSeriesDataPoint[] = [];
    let intervals = new Map<number, DataPoint[]>();

    for (let dataSet of dataSets) {
        if (!dataSet.data) {
            continue;
        }

        for (let data of dataSet.data) {
            addToInterval(intervals, new Date(Date.parse(data.key)).getTime(), dataSet.id, data.value);
        }
    }

    intervals.forEach((value, key) => {
        mergedData.push({
            key: new Date(key),
            value
        });
    });

    return mergedData;
};

const DashboardInvitesStatsChart: React.FC<DashboardInvitesStatsChartProps> = (props) => {
    return (
        <ChartSectionContainer>
            <SectionHeader>Email Invites Sent to Existing Users vs New Users</SectionHeader>

            <Legend
                items={[
                    {
                        name: 'Sent',
                        color: '#d9a5ff'
                    },
                    {
                        name: 'Existing User',
                        color: '#ffeda5'
                    },
                    {
                        name: 'New User',
                        color: '#5cefff'
                    }
                ]}
            />

            <SectionChart>
                {/* Three series line chart */}
                <CompositeDataProvider
                    dataFormat="TIME_SERIES"
                    sources={[
                        {
                            id: 'New User',
                            src: GET_INVITES_ENDPOINT,
                            options: {
                                isExistingUser: false,
                                type: InviteType.Email
                            },
                            handler: (res: any) => res.data
                        },
                        {
                            id: 'Existing User',
                            src: GET_INVITES_ENDPOINT,
                            options: {
                                isExistingUser: true,
                                type: InviteType.Email
                            },
                            handler: (res: any) => res.data
                        },
                        {
                            id: 'Sent',
                            src: GET_INVITES_ENDPOINT,
                            options: {
                                type: InviteType.Email
                            },
                            handler: (res: any) => res.data
                        }
                    ]}
                    merger={dataMerger}
                    options={{
                        ...props
                    }}
                    updateOnEventStrings={['INVITE_SENT']}
                    throttleMilliseconds={10000}
                >
                    <LineChartContainer
                        margin={{
                            top: 10,
                            right: 30,
                            left: 75,
                            bottom: 40
                        }}
                    />
                </CompositeDataProvider>
            </SectionChart>
        </ChartSectionContainer>
    );
};

export default DashboardInvitesStatsChart;
